import { render, staticRenderFns } from "./VendasVendedoresBI.vue?vue&type=template&id=0955c7fa"
import script from "./VendasVendedoresBI.vue?vue&type=script&lang=js"
export * from "./VendasVendedoresBI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports